<template>
  <div class="container">
    <router-link to="/"><Logo height="32" alt="Superchargify Logo" class="mb-5" /></router-link>

    <form class="user-input" @submit="submit">
      <input type="url" class="form-control form-control-lg mb-3" v-model="url" :disabled="!ready" required placeholder="Enter URL of a product, collection or blog post">
      <button type="submit" class="btn btn-primary btn-lg" :disabled="!ready">Preview</button>

      <div class="demo-link text-muted">
        <p><em>or</em></p>
        <p class="mb-0">Load demo <u @click="url = 'https://demo.superchargify.com/products/dark-denim-top'">product</u> / <u @click="url = 'https://demo.superchargify.com/collections/super-products'">collection</u> / <u @click="url = 'https://demo.superchargify.com/blogs/news/sample-blog-post'">blog post</u> link</p>
      </div>
    </form>

    <Footer class="mt-5" />
  </div>
</template>

<script>
import Logo from '@/components/Logo'
import Footer from '@/components/Footer'

export default {
  components: {
    Logo,
    Footer
  },
  data () {
    return {
      url: null,
      ready: true
    }
  },
  methods: {
    async submit (e) {
      e.preventDefault()

      this.ready = false

      this.$router.push({ name: 'preview', query: { url: this.url } })

      return false
    }
  }
}
</script>

<style lang="scss">
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px;

  .user-input {
    width: 100%;
    max-width: 560px;

    .demo-link {
      font-size: 0.85rem;
      // display: flex;
      // justify-content: flex-end;
      // text-transform: uppercase;
      font-weight: 400;
      margin-top: 1.5rem;

      u {
        cursor: pointer;
        // margin-left: 3px;
        // margin-right: 3px;
      }
    }
  }
}
</style>
